<div class="container-notepad">
    <div class="container-text-area">
        <textarea class="textinput" [(ngModel)]="text" cvLocalizedPlaceholder langSection="Module" langKey="Type_Here"></textarea>
    </div>
</div>